module.exports = __webpack_public_path__ + "img/sermep.45a6acb9.png";